// import ApiClient from "../helpers/ApiClient";
// import axios from "axios";
// import { API } from "../config/config";
// import { clearUserDetailsInLocalStorage } from "../helpers/UserDetails";
// import useSWR from "swr";

// export async function signIn(username, password) {
//   axios.defaults.withCredentials = true;
//   try {
//     const response = await axios.post(`${API}/superadmin/signin`, {
//       username, password
//     });

//     return response;
//   } catch (error) {
//     throw error;
//   }
// }


// export async function signOut() {
//   axios.defaults.withCredentials = true;
//   try {
//     const response = await ApiClient.post(`${API}/superadmin/signout`);

//     clearUserDetailsInLocalStorage();

//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

// export function useSuperAdminDashboard() {
//   const APIURL = `/superadmin/dashboard`;
//   const { data, error, isLoading } = useSWR(APIURL, fetcher);
//   return {
//     data,
//     error,
//     isLoading,
//     APIURL,
//   };
// }

// export function useSuperAdminTenantsData() {
//   const APIURL = `/superadmin/tenantsData`;
//   const { data, error, isLoading } = useSWR(APIURL, fetcher);
//   return {
//     data,
//     error,
//     isLoading,
//     APIURL,
//   };
// }

// export async function getSuperAdminTenantsData() {
//   try {
//     const APIURL = `/superadmin/tenantsData`;
//     const response = await ApiClient.get(APIURL);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }
// export async function getTenantsData({page, perPage, search, status , type , from , to}) {
//   try {
//     const response = await ApiClient.get(`${API}/superadmin/tenants?page=${page}&perPage=${perPage}&search=${search}&status=${status}&type=${type}&from=${from}&to=${to}`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// export async function addTenant(name , email , password , isActive) {
//   try {
//     const response = await ApiClient.post(`${API}/superadmin/tenants/add`, {
//       name , email , password , isActive
//     });

//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// export async function updateTenant(name , email , isActive , id) {
//   try {
//     const response = await ApiClient.patch(`${API}/superadmin/tenants/update/${id}`, {
//       name , email , isActive
//     });
//         return response;
//     } catch (error) {
//         throw error;
//     }
// }

// export async function deleteTenant(id) {
//   try {
//     const response = await ApiClient.delete(`${API}/superadmin/tenants/delete/${id}`);

//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// export async function getTenantsDataByStatus(status) {
//   try {
//     const response = await ApiClient.get(`${API}/superadmin/tenantsData/${status}`);

//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// export function useSuperAdminReports({ type, from = null, to = null }) {
//   const APIURL = `/superadmin/reports?type=${type}&from=${from}&to=${to}`;
//   const { data, error, isLoading } = useSWR(APIURL, fetcher);
//   return {
//     data,
//     error,
//     isLoading,
//     APIURL,
//   };
// }

// export function useSuperAdminTenantSubscriptionHistory(tenantId) {
//   const APIURL = `/superadmin/tenants/${tenantId}/subscription-history`;
//   const { data, error, isLoading } = useSWR(APIURL, fetcher);
//   return {
//     data,
//     error,
//     isLoading,
//     APIURL,
//   };
// }

import ApiClient from "../helpers/ApiClient";
import axios from "axios";
import { API } from "../config/config";
import { 
  clearUserDetailsInLocalStorage, 
  saveUserDetailsInLocalStorage,
  getUserDetailsInLocalStorage 
} from "../helpers/UserDetails";
import useSWR from "swr";

// Configure axios defaults
axios.defaults.withCredentials = true;

export async function signIn(username, password) {
  try {
    console.log('🔐 Attempting sign in with username:', username);
    
    const response = await axios.post(`${API}/superadmin/signin`, {
      username, 
      password
    });

    console.log('✅ Sign in response:', response);
    console.log('🔑 Access token:', response.data.accessToken);
    console.log('👤 User data:', response.data.user);

    if (response.status === 200 && response.data.user) {
      // Create complete user object with token
      const userWithToken = {
        ...response.data.user,
        token: response.data.accessToken // Add the token to user object
      };
      
      console.log('💾 Complete user object to save:', userWithToken);
      
      // Save complete user details to localStorage
      saveUserDetailsInLocalStorage(userWithToken);
      
      // Also set the token for ApiClient for future requests
      if (response.data.accessToken) {
        ApiClient.defaults.headers.common['Authorization'] = `Bearer ${response.data.accessToken}`;
        console.log('✅ Token set for ApiClient');
      }

      return response;
    }
    
    return response;
  } catch (error) {
    console.error('❌ Sign in error:', error);
    throw error;
  }
}

export async function signOut() {
  try {
    console.log('🚪 Attempting sign out');
    
    try {
      await ApiClient.post("/superadmin/signout");
    } catch (apiError) {
      console.warn("Backend superadmin signout warning:", apiError);
    }

    // Always clear user details from localStorage
    clearUserDetailsInLocalStorage();

    // Clear authorization header
    delete ApiClient.defaults.headers.common['Authorization'];
    
    try {
      sessionStorage.clear();
    } catch (_) {}

    console.log('✅ Sign out successful');

    return { status: 200, data: { message: "Logged out successfully" } };
  } catch (error) {
    console.error('❌ Sign out error:', error);
    clearUserDetailsInLocalStorage();
    delete ApiClient.defaults.headers.common['Authorization'];
    return { status: 200, data: { message: "Logged out successfully" } };
  }
}

// Enhanced fetcher that handles authentication
const fetcher = async (url) => {
  try {
    // Ensure we have the latest token for each request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }

    const response = await ApiClient.get(url);
    return response.data;
  } catch (error) {
    console.error('❌ Fetcher error:', error);
    
    // If unauthorized, clear local storage and redirect
    if (error.response?.status === 401) {
      clearUserDetailsInLocalStorage();
      delete ApiClient.defaults.headers.common['Authorization'];
      window.location.href = '/'; // Force redirect to login
    }
    
    throw error;
  }
};

// Initialize token on module load
(function initializeAuth() {
  const userDetails = getUserDetailsInLocalStorage();
  if (userDetails?.token) {
    ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    console.log('🔑 Token initialized from localStorage');
  }
})();

export function useSuperAdminDashboard() {
  const APIURL = `/superadmin/dashboard`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  });
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}

export function useSuperAdminTenantsData() {
  const APIURL = `/superadmin/tenantsData`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  });
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}

export async function getSuperAdminTenantsData() {
  try {
    const APIURL = `/superadmin/tenantsData`;
    
    // Ensure token is set for this request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }
    
    const response = await ApiClient.get(APIURL);
    return response;
  } catch (error) {
    console.error('❌ getSuperAdminTenantsData error:', error);
    throw error;
  }
}

export async function getTenantsData({page, perPage, search, status, type, from, to}) {
  try {
    // Ensure token is set for this request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }
    
    const response = await ApiClient.get(
      `${API}/superadmin/tenants?page=${page}&perPage=${perPage}&search=${search}&status=${status}&type=${type}&from=${from}&to=${to}`
    );
    return response;
  } catch (error) {
    console.error('❌ getTenantsData error:', error);
    throw error;
  }
}

export async function addTenant(name, email, password, isActive, enabledModules, maxUsers = 10, subscriptionStart = null, subscriptionEnd = null) {
  try {
    // Ensure token is set for this request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }
    
    const response = await ApiClient.post(`${API}/superadmin/tenants/add`, {
      name, email, password, isActive, enabledModules, max_users: maxUsers, subscription_start: subscriptionStart, subscription_end: subscriptionEnd
    });
    return response;
  } catch (error) {
    console.error('❌ addTenant error:', error);
    throw error;
  }
}

export async function updateTenant(name, email, isActive, id, enabledModules, paymentConfigs = {}, maxUsers) {
  try {
    // Ensure token is set for this request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }
    
    const response = await ApiClient.patch(`${API}/superadmin/tenants/update/${id}`, {
      name, email, isActive, enabledModules, ...paymentConfigs, maxUsers
    });
    return response;
  } catch (error) {
    console.error('❌ updateTenant error:', error);
    throw error;
  }
}

export async function deleteTenant(id) {
  try {
    // Ensure token is set for this request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }
    
    const response = await ApiClient.delete(`${API}/superadmin/tenants/delete/${id}`);
    return response;
  } catch (error) {
    console.error('❌ deleteTenant error:', error);
    throw error;
  }
}

export async function getTenantsDataByStatus(status) {
  try {
    // Ensure token is set for this request
    const userDetails = getUserDetailsInLocalStorage();
    if (userDetails?.token) {
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${userDetails.token}`;
    }
    
    const response = await ApiClient.get(`${API}/superadmin/tenantsData/${status}`);
    return response;
  } catch (error) {
    console.error('❌ getTenantsDataByStatus error:', error);
    throw error;
  }
}

export function useSuperAdminReports({ type, from = null, to = null }) {
  const APIURL = `/superadmin/reports?type=${type}&from=${from}&to=${to}`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  });
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}

export function useSuperAdminTenantSubscriptionHistory(tenantId) {
  const APIURL = `/superadmin/tenants/${tenantId}/subscription-history`;
  const { data, error, isLoading } = useSWR(APIURL, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  });
  return {
    data,
    error,
    isLoading,
    APIURL,
  };
}